module.exports = __webpack_public_path__ + "static/media/junior_tour_step4.baa9dae3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gJunior/junior_tour_step4.svg
// module id = 330
// module chunks = 21